import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class FileUtilService {
    private fileIconCache = new Map<string, string>();

    getFileIcon(name: string): string {
        if (!name) {
            return 'fa-file';
        }

        // Check cache first
        const cacheKey = name.toLowerCase();
        const cachedIcon = this.fileIconCache.get(cacheKey);
        if (cachedIcon) {
            return cachedIcon;
        }

        const icon = this.determineFileIcon(name);

        // Cache the result
        this.fileIconCache.set(cacheKey, icon);

        return icon;
    }

    private determineFileIcon(name: string): string {
        const fileName = name.toLowerCase();
        const fields = fileName.split('.');
        const suffix = fields.length > 1 ? fields[fields.length - 1] : null;
        if (!suffix) {
            return 'fa-file';
        }
        const iconMap: Record<string, string> = {
            'pdf': 'fa-file-pdf-o',
            'csv': 'fa-file-excel-o',
            'xls': 'fa-file-excel-o',
            'xlsx': 'fa-file-excel-o',
            'ods': 'fa-file-excel-o',
            'jpg': 'fa-file-image-o',
            'jpeg': 'fa-file-image-o',
            'png': 'fa-file-image-o',
            'gif': 'fa-file-image-o',
            'bmp': 'fa-file-image-o',
            'tif': 'fa-file-image-o',
            'tiff': 'fa-file-image-o',
            'doc': 'fa-file-word-o',
            'docx': 'fa-file-word-o',
            'odt': 'fa-file-word-o',
            'rtf': 'fa-file-text-o',
            'txt': 'fa-file-text-o',
            'zip': 'fa-file-archive-o',
            'jar': 'fa-file-archive-o',
            'war': 'fa-file-archive-o',
            'rar': 'fa-file-archive-o',
            'ppt': 'fa-file-powerpoint-o',
            'pptx': 'fa-file-powerpoint-o',
            'mp3': 'fa-file-audio-o',
            'wav': 'fa-file-audio-o',
            'mp4': 'fa-file-video-o',
            'avi': 'fa-file-video-o',
            'mov': 'fa-file-video-o',
            'mpg': 'fa-file-video-o'
        };

        return iconMap[suffix] || 'fa-file-o';
    }
}